export default "__VITE_ASSET__DDJ1naRp__"